import LegalDocViewer from "@/components/LegalDocViewer";
import content from "@/legal-rendered/recording_consent";

export default function RecordingConsentPage() {
  return (
    <LegalDocViewer
      title="Recording & AI Consent"
      subtitle="How we treat session recording, transcription and AI-generated outputs"
      policyId="recording_consent"
      policyVersion="1.1.0"
      content={content}
    />
  );
}
